import TextField, {TextFieldProps} from '@material-ui/core/TextField'
import {useEvent} from 'Event/EventProvider'
import {onChangeStringHandler} from 'lib/dom'
import React from 'react'
import {ZapierTag} from 'Event/zapier'

export default function ZapierTagInput(
  props: Omit<TextFieldProps, 'value' | 'onChange'> & {
    onChange: (tag: ZapierTag | null) => void
    value?: ZapierTag | null
  },
) {
  const {disabled, value, onChange, ...textFieldProps} = props
  const {event} = useEvent()

  const name = value?.name || ''

  if (!event.has_zapier) {
    return null
  }

  return (
    <TextField
      value={name}
      label="Zapier Tag"
      fullWidth
      inputProps={{
        'aria-label': 'zapier tag',
      }}
      onChange={onChangeStringHandler((name) => onChange({name}))}
      disabled={disabled}
      helperText={'Add zapier tag, when user tag an action'}
      {...textFieldProps}
    />
  )
}
